<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
    <p style="font-size: 20px; color: white">Aguarde ...</p>
  </ngx-spinner>
  
  <div class="col-sm-12 col-xl-12 ">
    <!-- Default select start -->
    <app-card cardTitle="Perguntas Cadastradas" [options]="false">
      <div class="row">
        <div class="col-12">
          <input type="text" class="form-control" [(ngModel)]="query"
            placeholder="Digite seu filtro, sera feito uma busca em todas as colunas">
        </div>
        <div class="col-12">
          <div class="list-group list-group-flush mt-3" style="max-height:480px; overflow-y:auto;">
            <div class="list-group-item" *ngFor="let item of arrayPerguntas | fullTextSearch:query">
              <div class="row">
                <div class="col-12 col-lg-3 mb-3 mb-lg-0">
                  <small class="text-uppercase text-muted d-block">Instrumentos/Escala</small>
                  <span class="font-weight-semibold d-block text-break">{{item.grupO_DESCRICAO }}</span>
                </div>
                <div class="col-12 col-lg-4 mb-3 mb-lg-0">
                  <small class="text-uppercase text-muted d-block">Título</small>
                  <span class="d-block text-break">{{item.titulo }}</span>
                </div>
                <div class="col-12 col-lg-5">
                  <small class="text-uppercase text-muted d-block">Descrição</small>
                  <span class="d-block text-break">{{item.descricao }}</span>
                </div>
              </div>
              <div class="row mt-3">
                <div class="col-12 col-md-4 col-lg-3 mb-3 mb-md-0">
                  <small class="text-uppercase text-muted d-block">TAG</small>
                  <span class="d-block text-break">{{item.tag }}</span>
                </div>
                <div class="col-12 col-md-4 col-lg-2 mb-3 mb-md-0">
                  <small class="text-uppercase text-muted d-block">Tipo Campo</small>
                  <span class="d-block text-break">{{item.tipO_DESCRICAO}}</span>
                </div>
                <div class="col-12 col-md-4 col-lg-2 mb-3 mb-md-0">
                  <small class="text-uppercase text-muted d-block">Status</small>
                  <span class="d-block">
                    <span *ngIf="item.revisado" class="badge badge-success">Revisado</span>
                    <span *ngIf="!item.revisado" class="badge badge-danger">Não Revisado</span>
                  </span>
                </div>
                <div class="col-12 col-md-6 col-lg-5 text-md-right">
                  <small class="text-uppercase text-muted d-block">Ações</small>
                  <button type="button" class="btn btn-info btn-sm mr-2 mt-1" (click)="visualizarPerguntas(item)"
                    ngbTooltip="Editar Pergunta">
                    <i class="fa fa-eye"></i> Visualizar
                  </button>
                  <button type="button" class="btn btn-danger btn-sm mt-1" (click)="desabilitar(item.id)">
                    <i class="fa fa-trash"></i> Excluir
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
  
    </app-card>
  </div>
  
  <!--
    <app-ui-modal #myLargeModalLabel [hideFooter]="true" [dialogClass]="'modal-lg'">
    <div class="app-modal-header">
      <h5 class="modal-title">Modal Title</h5>
      <button type="button" class="close basic-close" data-dismiss="modal" aria-label="Close"
        (click)="myLargeModalLabel.hide()"><span aria-hidden="true">&times;</span></button>
    </div>
    <div class="app-modal-body">
     <app-visualizar-perguntas *ngIf="perguntaSelecionada" [pergunta]="perguntaSelecionada"></app-visualizar-perguntas>
    </div>
  </app-ui-modal>
  -->
  